import React from 'react';
import { Modal as MantineModal } from '@mantine/core';

export interface ModalProps extends React.ComponentPropsWithoutRef<typeof MantineModal> {
  /** Whether the modal is open */
  opened: boolean;
  /** Called when modal should close (X, overlay click, escape) */
  onClose: () => void;
  /** Modal title */
  title?: React.ReactNode;
  /** Modal content */
  children: React.ReactNode;
  /** Optional CSS class name */
  className?: string;
  /** Size: xs, sm, md, lg, xl, or custom (e.g. "500px") */
  size?: string | number;
  /** Show close button in header. Default: true */
  withCloseButton?: boolean;
  /** Center modal vertically. Default: true */
  centered?: boolean;
  /** Stack above fixed app chrome (e.g. Exam Portal header at z-index 300). Default: 400 */
  zIndex?: number | string;
}

/**
 * Generic modal component. Wraps Mantine Modal for consistent use across the app.
 */
export function Modal({
  opened,
  onClose,
  title,
  children,
  className,
  size = 'md',
  withCloseButton = true,
  centered = true,
  zIndex = 400,
  ...rest
}: ModalProps) {
  return (
    <MantineModal
      opened={opened}
      onClose={onClose}
      title={title}
      className={className}
      size={size}
      withCloseButton={withCloseButton}
      centered={centered}
      zIndex={zIndex}
      {...rest}
    >
      {children}
    </MantineModal>
  );
}

export default Modal;
